import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

require('script-loader!.tmp/js/templates/location/modules/ChatWidget.js');

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { Yext } from 'js/components/Soy2js/Soy2js.js'; // NOTE: if not using soy2js, replace with window.Yext = window.Yext || {};

import { GoogleAdwords } from 'js/components/GoogleAdwords/index.js'; /* TODO: remove if unused */
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js'; /* TODO: remove if unused */
import { LocationHours } from 'js/components/LocationHours/index--override.js'; /* TODO: remove if unused */
import { Instance } from 'js/components/Maps/GoogleMapsAPI.js';
import { Maps } from 'js/components/Maps/index.js'; /* TODO: remove if unused */
import { CustomMap } from 'js/CustomMap.js'; /* TODO: remove if unused */
import { FAQ } from 'js/components/FAQ/index.js';
import { RunIfVisible } from 'js/components/RunIfVisible/index.js';
import { Events } from 'js/common/modules/Events.js';

Yext.Maps = Maps;
Yext.Maps.CustomMap = CustomMap;

Global.init();
GoogleAdwords.init();
GoogleAnalytics.enableAutotracking('yext');
FAQ.init();

OnReady(() => {
  Yext.Maps.CustomMap.initClass();
  LocationHours.loadAndRun();

  const map = document.querySelector('.location-map-wrapper');
  if (map) {
    RunIfVisible.runIfTargetVisible(map, () => {
      Maps.loadAndRun();
      Instance.load();
    })
  }

  RunIfVisible.lazyLoadImages('.js-lazy');

  $('.About-link').click(function(e) {
    e.preventDefault();
    const target = $($(this).attr('href'));
    const top = target.offset().top;
    $('html, body').animate({
      scrollTop: top
    }, 1500);
  });

  manageBannerVisibility();

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const macOS = window.navigator.platform.includes('Mac');
  // Add apple chat widget to apple devices only
  if ((isIOS || macOS) && Yext.showWidget) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "https://static.cdn-apple.com/businesschat/start-chat-button/2/index.js";
    document.head.appendChild(script);
    script.addEventListener('load', function() {
      appleBusinessChat.refresh();
    });

    const targetNode = document.querySelector('.apple-business-chat-banner-container');

    const config = { childList: true };

    const callback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          let contactUsIFrame = document.querySelector('iframe');
          contactUsIFrame.classList.add('js-contact-us-iframe');
          if (contactUsIFrame) {
            focus();
            window.addEventListener('blur', function() {
              if (document.activeElement.tagName == 'IFRAME' && document.activeElement.classList.contains('js-contact-us-iframe') && !document.activeElement.listener) {
                // fire once per iframe
                document.activeElement.listener = true;
                Yext.Analytics.trackEvent('applechat_cta');
              }
            });
            observer.disconnect();
          }
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(targetNode, config);
  } else if (Yext.showWidget) {
    // Replaces section id in script with
    let sectionId = '[ "Nationwide", "Branch", "Appointment-Queue"]';
    if (Yext.chatWidgetSectionID) {
      sectionId = Yext.chatWidgetSectionID;
    }

    let androidScript = `window.lpTag=window.lpTag||{},'undefined'==typeof window.lpTag._tagCount?(window.lpTag={wl:lpTag.wl||null,scp:lpTag.scp||null,site:'78722355'||'',section:${sectionId}||'',tagletSection:lpTag.tagletSection||null,autoStart:lpTag.autoStart!==!1,ovr:lpTag.ovr||{},_v:'1.10.0',_tagCount:1,protocol:'https:',events:{bind:function(t,e,i){lpTag.defer(function(){lpTag.events.bind(t,e,i)},0)},trigger:function(t,e,i){lpTag.defer(function(){lpTag.events.trigger(t,e,i)},1)}},defer:function(t,e){0===e?(this._defB=this._defB||[],this._defB.push(t)):1===e?(this._defT=this._defT||[],this._defT.push(t)):(this._defL=this._defL||[],this._defL.push(t))},load:function(t,e,i){var n=this;setTimeout(function(){n._load(t,e,i)},0)},_load:function(t,e,i){var n=t;t||(n=this.protocol+'//'+(this.ovr&&this.ovr.domain?this.ovr.domain:'lptag.liveperson.net')+'/tag/tag.js?site='+this.site);var o=document.createElement('script');o.setAttribute('charset',e?e:'UTF-8'),i&&o.setAttribute('id',i),o.setAttribute('src',n),document.getElementsByTagName('head').item(0).appendChild(o)},init:function(){this._timing=this._timing||{},this._timing.start=(new Date).getTime();var t=this;window.attachEvent?window.attachEvent('onload',function(){t._domReady('domReady')}):(window.addEventListener('DOMContentLoaded',function(){t._domReady('contReady')},!1),window.addEventListener('load',function(){t._domReady('domReady')},!1)),'undefined'===typeof window._lptStop&&this.load()},start:function(){this.autoStart=!0},_domReady:function(t){this.isDom||(this.isDom=!0,this.events.trigger('LPT','DOM_READY',{t:t})),this._timing[t]=(new Date).getTime()},vars:lpTag.vars||[],dbs:lpTag.dbs||[],ctn:lpTag.ctn||[],sdes:lpTag.sdes||[],hooks:lpTag.hooks||[],identities:lpTag.identities||[],ev:lpTag.ev||[]},lpTag.init()):window.lpTag._tagCount+=1;`;

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = androidScript;
    document.head.appendChild(script);

    const targetNode = document.querySelector('body');

    const config = { childList: true };

    const callback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          let contactUsButton = document.querySelector('.LPMcontainer');
          if (contactUsButton) {
            if (Yext.newChatLocation) {
              let newChatLocation = document.querySelector('.js-newChatLocation');
              newChatLocation.appendChild(contactUsButton);
            }

            contactUsButton.addEventListener('click', () => {
              Yext.Analytics.trackEvent('windowschat_cta');
            });
          }
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(targetNode, config);
  }

  new Events();

  window.addEventListener('resize', () => {
    // On desktop, if the additional info section is populated, client wants an equal
    // vertical height between the get directions button and the address; and the get directions
    // button and the additional info section. Additionally, they want the additional info section
    // to be horizontally aligned with the additional hours text.
    const getDirectionsEl = document.querySelector('.js-nap-directions');
    const hoursAdditionalTextEl = document.querySelector('.js-hours-additional-text');
    const napAdditionalInfoEl  = document.querySelector('.js-nap-additional-info');
    if (getDirectionsEl && hoursAdditionalTextEl && napAdditionalInfoEl) {

      if (window.innerWidth >= 992) {
        const heightReduceFunc = (previousValue, child) => previousValue + child.offsetHeight;

        const leftNapChildren = Array.from(getDirectionsEl.parentElement.childNodes);
        const leftHeightOccupiedToTarget = leftNapChildren.slice(0, leftNapChildren.indexOf(getDirectionsEl)).reduce(heightReduceFunc, 0);

        const rightNapChildren = Array.from(hoursAdditionalTextEl.parentElement.childNodes);
        const rightHeightOccupiedToTarget = rightNapChildren.slice(0, rightNapChildren.indexOf(rightNapChildren)).reduce(heightReduceFunc, 0);

        // due to styling, it will always be the case that rightHeightOccupiedToTarget >= leftHeightOccupiedToTarget + parseFloat(window.getComputedStyle(hoursAdditionalTextEl).marginTop)
        const heightToTargetDiff = rightHeightOccupiedToTarget - leftHeightOccupiedToTarget - parseFloat(window.getComputedStyle(hoursAdditionalTextEl).marginTop);
        getDirectionsEl.style.paddingTop = `${heightToTargetDiff / 2}px`;
        getDirectionsEl.style.paddingBottom = `${heightToTargetDiff / 2}px`;
      } else {
        getDirectionsEl.style.paddingTop = null;
        getDirectionsEl.style.paddingBottom = null;
      }
    }
  })
  window.dispatchEvent(new Event('resize'))


  // - The un-minified file is different than the minified one :/
  // - Uncomment the following if using JVector map
  // VectorMap.autorun();
});

function manageBannerVisibility() {
  const bannerEl = document.querySelector('.NAP-banner');

  if (bannerEl) {
    const startDateTimeString = bannerEl.dataset.startDateTime;
    const endDateTimeString = bannerEl.dataset.endDateTime;

    if (!startDateTimeString || !endDateTimeString) {
      bannerEl.style.display = 'none';
      return;
    }

    const now = new Date();
    const startDate = new Date(startDateTimeString);
    const endDate = new Date(endDateTimeString);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      bannerEl.style.display = 'none';
    } else {
      if (now >= startDate && now <= endDate) {
        bannerEl.style.display = 'block';
      } else {
        bannerEl.style.display = 'none';
      }
    }
  }
}
